 
import { NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NbInputModule } from '@nebular/theme';

@Component({
    selector: 'app-string-translation',
    templateUrl: './string-translation.component.html',
    styleUrls: ['./string-translation.component.css'],
    imports: [NgIf, NbInputModule, FormsModule]
})
export class StringTranslationComponent implements OnInit {
  @Input() public language: object;
  @Input() public xliff: object;
  @Input() public editable = true;

  public languageDisplay: string;

  constructor() {}

  public ngOnInit(): void {
    this.languageDisplay = this.language['key'] + ' - ' + this.language['value'];
  }
}
